// Backend API URL
// Uses Vercel serverless function (/api/contact) for both local dev and production
const API_URL = process.env.REACT_APP_API_URL || '';

export const sendContactEmail = async (formData) => {
  try {
    const { name, email, message, interest } = formData;

    // Send data to backend API
    const response = await fetch(`${API_URL}/api/contact`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        name,
        email,
        message,
        interest
      })
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || 'Failed to send email');
    }

    return { success: true, messageId: data.messageId };
  } catch (error) {
    console.error('Error sending email:', error);
    return {
      success: false,
      error: error.message || 'Failed to send email'
    };
  }
};